import { useEffect, useState } from 'react';
import TabCard from './TabCard/TabCard';
import RutasIngrales from './RutasIngrales/RutasIngrales';
import RutasTransversales from './RutasTransversales/RutasTransversales';

const tabs = {
  serviciosTransversales: {
    name: 'serviciosTransversales',
    component: RutasTransversales,
  },
  serviciosIntegralesSalud: { name: 'serviciosIntegralesSalud', component: RutasIngrales },
};

function ActiveSection({ activeTab, list }) {
  const ActiveComponent = activeTab;
  return <ActiveComponent list={list} />;
}

function RutasServicios() {
  const [activeTab, setActiveTab] = useState(null);
  const [routeServicesList, setRouteServicesList] = useState([]);

  const getServiceRoutes = () => {
    const pnpService = new ServicioPnp();
    pnpService.getListByTitle(
      'RutasServicios',
      (list) => {
        setRouteServicesList(list);
      },
      null,
      [
        'CSDescripcionRutasext',
        'CSNombreCertificadoText',
        'CSURLCertificadoText',
        'Color',
        'esRutaIntegral',
        'TipoFiltro',
      ],
    );
  };

  useEffect(() => {
    getServiceRoutes();
  }, []);

  return (
    <div className="row selectorPadre" id="rutas-servicios">
      <div className="loadingWraper">
        <div className="compensarLoading">
          <span>cargando... </span>
        </div>
      </div>
      {/* Compoente Cards Principales*/}
      <nav className="TabCardsContainer">
        {parseText('rutasServicios.tabs.config').map((tab) => (
          <TabCard
            title={tab.title}
            img={tab.img}
            onClick={() => setActiveTab(tabs[tab.id].name)}
            id={tab.id}
            color={tab.color}
            active={tabs[tab.id].name === activeTab}
          />
        ))}
      </nav>
      {/* Compoente Cards Servicios*/}
      {activeTab && <ActiveSection list={routeServicesList} activeTab={tabs[activeTab].component} />}

      {/* Compoente Select Busqueda*/}
      {/* Compoente Tabla*/}
    </div>
  );
}

export default RutasServicios;
